import axios, { AxiosInstance } from "axios";
import {
  CatalogueFilterQuery,
  DeliveryCalendarQuery,
  DeliveryCalendarResult,
  SearchAppResult
} from "../common/interfaces";

const SEARCH_APP_PATH = "/se?path=";
const DELIVERY_CALENDAR_PATH = "/delivery-calendar";

export interface FilterRequestBody {
  query: CatalogueFilterQuery;
  styleCodes?: string[];
}

export class ServerGateway {
  private readonly axiosInstance: AxiosInstance;

  constructor() {
    let baseURL: string;
    let host = "";
    if (typeof window !== "undefined") {
      host = window.location.host;
    }

    if (/staging/.test(host)) {
      baseURL = "https://catalogue.staging.glamcorner.com.au";
    } else if (/website.local/.test(host)) {
      baseURL = "http://catalogue.local.glamcorner.com.au";
    } else {
      baseURL = "https://catalogue.glamcorner.com.au";
    }

    this.axiosInstance = axios.create({
      baseURL,
      timeout: 10000
    });
  }

  async filterRequest(body: FilterRequestBody): Promise<SearchAppResult | null> {
    const requestDataString = JSON.stringify({ body });
    const options = {
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        Accept: "application/json"
      }
    };

    try {
      const result = await this.axiosInstance.post("/api/v3/catalogue", requestDataString, options);
      return result.data.body;
    } catch (e) {
      return null;
    }
  }

  async deliveryCalendar(query: DeliveryCalendarQuery): Promise<DeliveryCalendarResult | null> {
    const postcode = query.postcode;
    let requestPath = `${DELIVERY_CALENDAR_PATH}${postcode ? `?postcode=${postcode}` : ""}`;
    let url = `${this.getSearchAppPath()}${encodeURIComponent(requestPath)}`;

    try {
      const {
        data: { body }
      } = await this.axiosInstance.get(url);
      return body;
    } catch (e) {
      return null;
    }
  }

  private getSearchAppPath() {
    return `${window.location.protocol}//${window.location.hostname}${SEARCH_APP_PATH}`;
  }
}
